module.exports = __webpack_public_path__ + "static/media/forward.699765ee.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/ui/forward.svg
// module id = 171
// module chunks = 0